export const experience = [
  {
    title: "دسترسی همیشگی",
    desc: "اتصال پایدار به سرویس‌ها، هم در اوج ترافیک و هم به منابع بین‌المللی تحریم‌شده",
    logo: "disaster.svg",
    imgAlt: "دسترسی همیشگی",
    imgTitle: "دسترسی همیشگی",
  },
  {
    title: "بدون محدودیت",
    desc: "اتصال بی‌وقفه و مقیاس‌پذیر، دسترسی آزاد بدون وابستگی به ابزار جانبی",
    logo: "startup.svg",
    imgAlt: "بدون محدودیت",
    imgTitle: "بدون محدودیت",
  },
  {
    title: "پشتیبانی اختصاصی",
    desc: "پشتیبانی Proactive ۲۴/۷ شبکه ابری توسط تیم فنی و متخصص آبالون",
    logo: "virtualOrganization.svg",
    imgAlt: "پشتیبانی اختصاصی",
    imgTitle: "پشتیبانی اختصاصی",
  },
  {
    title: "متناسب با نیاز شما",
    desc: "رفع محدودیت‌های دسترسی به‌دلیل تحریم خارجی یا ترافیک بالای شبکه",
    logo: "test.svg",
    imgAlt: "متناسب با نیاز شما",
    imgTitle: "متناسب با نیاز شما",
  },
];

export const loadbalancer = [
  {
    title: "لود بالانسر DNS آبالون",
    subtitle: "مستقل از پروتکل ارتباطی",
    desc: "هدایت ترافیک ساب‌دامین‌های مختلف میان چند سرور با تعریف رکورد‌های DNS",
  },
  {
    title: "لود بالانسر HTTP آبالون",
    subtitle: "برای سرویس‌های مبتنی بر وب",
    desc: "توزیع ترافیک میان سرورهای CDN با اعمال قوانین مسیریابی روی دامنه یا url",
  },
  {
    title: "لود بالانسر ابری آبالون",
    subtitle: "بدون وابستگی به دامنه",
    desc: "توزیع ترافیک ارسالی به‌ ماشین‌های مجازی یا سرورها از هر جا بر اساس IP",
  },
];

export const popularServices = [
  {
    title: "محصولات آبالون",
    desc: "با استفاده از محصولات ابری و دیتاسنتری آبالون، زیرساخت امن، پایدار و مقیاس‌پذیر سازمان‌تان را بدون پیچیدگی‌های فنی ایجاد کنید.",
    logo: "VPS-Service.svg",
    route: "/products",
    imgAlt: "محصولات آبالون",
    imgTitle: "محصولات آبالون",
  },
  {
    title: "امنیت ابری",
    desc: "با استفاده از راهکارهای امنیتی پیشرفته مانند فضای کاری امن، فایروال ابری، WAF و سامانه SIEM از سرویس‌های سازمانی خود در فضای ابری محافظت کنید.",
    logo: "CloudGuard-Service.svg",
    route: "/cloud-security",
    imgAlt: "امنیت ابری",
    imgTitle: "امنیت ابری",
  },
  {
    title: "راهکارهای تخصصی آبالون",
    desc: "با راهکارهای تخصصی آبالون، بدون پیچیدگی فنی، مسیر مهاجرت، مدیریت و امنیت ابری را ساده‌تر کنید و سازمان‌تان را در مسیر رشد و تحول دیجیتال پیش ببرید.",
    logo: "VPC-Service.svg",
    route: "/solutions",
    imgAlt: "راهکارهای تخصصی آبالون",
    imgTitle: "راهکارهای تخصصی آبالون",
  },
  {
    title: "شبکه توزیع محتوای CDN آبالون",
    desc: "با بیش از ۴۰ پاپ‌سایت در ایران و ۵ قاره جهان، محتوای وب‌سایت و سرویس‌های آنلاین سازمان خود را با کمترین تأخیر، سریع‌تر و ایمن‌تر به کاربران برسانید.",
    logo: "ManagedService-Service.svg",
    route: "/cdn",
    imgAlt: "شبکه توزیع محتوای CDN آبالون",
    imgTitle: "شبکه توزیع محتوای CDN آبالون",
  },
];

export const questions = [
  {
    title: "شبکه ابری آبالون شامل چه سرویس‌هایی می‌شود؟",
    answer:
      "شبکه ابری آبالون شامل دو سرویس کلیدی است: لود بالانسر هوشمند برای توزیع پایدار ترافیک و تحریم‌شکن اختصاصی برای دسترسی مستقیم به منابع بین‌المللی.",
  },
  {
    title: "چه سازمان‌هایی به سرویس لودبالانسر آبالون نیاز دارند؟",
    answer:
      "کسب‌وکارهایی با چند سرور در هر جای ایران و جهان که سرویس‌های پرترافیک دارند (مانند وب‌سایت‌های پربازدید، اپلیکیشن‌های آنلاین و سامانه‌های دولتی) یا پلتفرم‌های تجارت الکترونیک که حتی چند دقیقه قطعی برایشان خسارت‌بار است، به یک راهکار توزیع بار نیاز دارند. لود بالانسر آبالون با توزیع هوشمند ترافیک، از کندی یا قطع سرویس جلوگیری کرده و پایداری زیرساخت شما را تضمین می‌کند.",
  },
  {
    title: "چه نوع سازمان‌هایی بیشترین بهره را از شبکه ابری آبالون می‌برند؟",
    answer:
      "سازمان‌های پرترافیک، پلتفرم‌های SaaS و Cloud، تیم‌های DevOps و همچنین شرکت‌هایی که نیازمند دسترسی پایدار به منابع بین‌المللی هستند، بیشترین ارزش را از شبکه ابری آبالون دریافت می‌کنند.",
  },
  {
    title: "برای استفاده از سرویس تحریم‌شکن آبالون چه پیش‌نیازهایی لازم است؟",
    answer:
      "سرویس تحریم‌شکن آبالون روی تمام سرویس‌های زیرساختی آبالون فعال است. تنها کافی است IPهای اختصاص‌داده‌شده را در تنظیمات DNS سرویس‌های خود وارد کنید و بدون نیاز به تغییرات پیچیده، به منابع بین‌المللی متصل شوید.",
  },
];
